import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {carouselData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselData.items.map((item) => (
            <a
              key={item.title}
              href={item.link}
              className="group bg-background-100 rounded-lg overflow-hidden no-underline block"
            >
              <div className="relative w-full h-[180px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}